export const getDisconnectedEmailAccountSend = ({
  emailSentTo,
  emailToReconnect
}) => ({
  key: 'disconnected-email-account-send',
  properties: {
    emailSentTo,
    emailToReconnect
  }
});